import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Change network to {networkName}',
  description: 'You’re currently connected to {networkName}. {additional}',
  additionalDescription: 'Change your current network in the wallet app to proceed.',
  networkIsNotSupportedCaption: 'Please connect another wallet',
  networkIsNotSupportedDescription: "Sorry, we don't support {networkName} on {walletName}",
  changeNetwork: 'Change network',

  howToChange: 'How to change to',
  goBack: 'Go back',
});
